import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.a`
  ${({ theme, displayState }) => css`
    text-decoration: underline;
    font-size: 0.75rem;
    color: ${theme?.colour?.primary ?? '#1bbd6b'};
    padding-left: ${displayState?.paddingLeft ?? ''};
  `}
`;


export default Atom({ type: 'button', dataType: 'string', template })